import { ReviewClip, ReviewTimeline, ReviewTimelineItem } from 'modules/match-video/domain/interfaces';

export const INTRO_DURATION_SEC = 3;
export const TRANSITION_DURATION_SEC = 0.5;

/**
 * Clips with a time go by time; clips without one go last in the order they were picked.
 * The sort is stable, so equal times keep the pick order too.
 */
export function sortReviewClips(clips: readonly ReviewClip[]): ReviewClip[] {
  return [...clips].sort((a, b) => {
    if (a.capturedAt && b.capturedAt) {
      return a.capturedAt.localeCompare(b.capturedAt);
    }
    if (a.capturedAt) {
      return -1;
    }
    if (b.capturedAt) {
      return 1;
    }
    return 0;
  });
}

/**
 * Intro, then a transition before every clip, the clips in the order given. That order is the list the user sees —
 * by camera time when added (`addReviewClips`), then as moved by hand — so it is not sorted again here.
 */
export function buildReviewTimeline(clips: readonly ReviewClip[]): ReviewTimeline {
  const items: ReviewTimelineItem[] = [{ type: 'intro', durationSec: INTRO_DURATION_SEC }];
  for (const clip of clips) {
    items.push({ type: 'transition', durationSec: TRANSITION_DURATION_SEC }, { type: 'clip', clip });
  }
  return { items };
}
